var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isLoadingAddresses && !_vm.isLoadingShippingAddress,
            expression: "!isLoadingAddresses && !isLoadingShippingAddress"
          }
        ]
      },
      [
        _vm.hasForbiddenProduct
          ? _c("div", { staticClass: "alert alert-danger" }, [
              _c("strong", [_vm._v("Nous vous informons que...")]),
              _c("br"),
              _vm._v(" "),
              _c(
                "ul",
                _vm._l(_vm.forbiddenCountriesProduct, function(p) {
                  return _c("li", [
                    _vm._v(
                      _vm._s(p) +
                        " n'est pas disponible à la vente dans votre pays."
                    )
                  ])
                })
              ),
              _vm._v("\n            Vous pouvez retourner dans "),
              _c("a", { attrs: { href: "/panier" } }, [_vm._v("votre panier")]),
              _vm._v(" pour modifier votre commande.\n        ")
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "blockAddresses" },
          [
            _c("h2", [_vm._v("Mes adresses")]),
            _vm._v(" "),
            _c(
              "ponroy-order-shipping-address",
              { attrs: { address: _vm.shippingAddress } },
              [
                _vm._t("shippingAddressForm", null, {
                  slot: "shippingAddressForm"
                }),
                _vm._v(" "),
                _vm._t("shippingAddressModalForm", null, {
                  slot: "shippingAddressModalForm"
                })
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "ponroy-order-billing-address",
              { attrs: { address: _vm.billingAddress } },
              [
                _vm._t("billingAddressForm", null, {
                  slot: "billingAddressForm"
                }),
                _vm._v(" "),
                _vm._t("billingAddressModalForm", null, {
                  slot: "billingAddressModalForm"
                })
              ],
              2
            )
          ],
          1
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isLoadingAddresses || _vm.isLoadingShippingAddress,
            expression: "isLoadingAddresses || isLoadingShippingAddress"
          }
        ],
        staticClass: "loader"
      },
      [_c("i", { staticClass: "fa fa-circle-o-notch fa-spin fa-2x" })]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11ea647d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11ea647d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/SiteBundle/Resources/assets/components/Order/OrderDelivery.vue
// module id = 546
// module chunks = 1